import React from 'react'

import {
  Box,
  Display,
  DisplayPosition,
  FlexDirection,
  Overflow,
} from '@gousto-internal/citrus-react'

import { Benefits } from './components/Benefits'
import { Background } from './components/Background'
import { MenuOverlay } from './components/MenuOverlay'
import { PatternOverlay } from './components/PatternOverlay'

export type EffortlessHomeCookingSectionProps = {
  signupCTA: string
  onCTAClick: () => void
}

export function EffortlessHomeCookingSection({
  signupCTA,
  onCTAClick,
}: EffortlessHomeCookingSectionProps) {
  return (
    <section data-testid="effortlessHomeCooking">
      <Box
        display={Display.Flex}
        flexDirection={[FlexDirection.Column, null, null, FlexDirection.Row]}
        overflowX={Overflow.Hidden}
        position={DisplayPosition.Relative}
      >
        <Box width={[null, null, null, '50%']}>
          <Benefits signupCTA={signupCTA} onCTAClick={onCTAClick} />
        </Box>
        <Box width={[null, null, null, '50%']}>
          <Background />
        </Box>
        <PatternOverlay />
        <MenuOverlay />
      </Box>
    </section>
  )
}
